import { useAppState } from "../contexts/AppContext";
import Login from "./login";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Auth, { checkAuth, logout, me } from "../helpers/Auth";
import { useEffect } from "react";
import { Link, usePage } from "@inertiajs/react";
import clsx from "clsx";


dayjs.extend(localizedFormat)
dayjs.extend(utc)
dayjs.extend(timezone)



export default function App({ children }: { children: React.ReactNode }) {
    const { appState, setAppState } = useAppState()

    const { url } = usePage();

    useEffect(() => {
        Auth.me().then((data) => {
            setAppState({
                user: {
                    name: data.user.name,
                    email: data.user.email,
                }
            })
        })
    }, [])

    if (!checkAuth()) {
        return <Login />
    }

    const hoverClasses = "hover:text-white hover:bg-[#ffffff0d] focus:text-white focus:bg-[#ffffff0d]";
    const activeClasses = "bg-[#101828] text-white";
    const defaultClasses = "p-2 rounded-md transition-colors text-sm font-medium";
    console.log(url)

    return (
        <div className="">
            <header className="w-full bg-[#1e2939]">
                <nav className="mx-auto max-w-7xl h-16 border-b border-[#101828] text-gray-100 flex items-center justify-between">
                    <ul className="flex items-center space-x-4">
                        {/* <li>
                            <Link className={clsx(['text-lg font-medium', url === '/admin' ? activeClasses : hoverClasses])} href="/admin">LAG</Link>
                        </li> */}
                        <li>
                            <Link className={clsx([defaultClasses, url === '/admin' ? activeClasses : hoverClasses])} href="/admin">Dashboard</Link>
                        </li>
                        <li>
                            <Link className={clsx([defaultClasses, url.startsWith('/admin/news') ? activeClasses : hoverClasses])} href="/admin/news">News</Link>
                        </li>
                        <li>
                            <Link className={clsx([defaultClasses, url.startsWith('/admin/pages') ? activeClasses : hoverClasses])} href="/admin/pages">Pages</Link>
                        </li>
                        <li>
                            <Link className={clsx([defaultClasses, url.startsWith('/admin/teams') ? activeClasses : hoverClasses])} href="/admin/teams">Teams</Link>
                        </li>
                        <li>
                            <Link className={clsx([defaultClasses, url.startsWith('/admin/opponents') ? activeClasses : hoverClasses])} href="/admin/opponents">Opponents</Link>
                        </li>
                        <li>
                            <Link className={clsx([defaultClasses, url.startsWith('/admin/staff') ? activeClasses : hoverClasses])} href="/admin/staff">Staff</Link>
                        </li>
                        <li>
                            <Link className={clsx([defaultClasses, url.startsWith('/admin/matches') ? activeClasses : hoverClasses])} href="/admin/matches">Matches</Link>
                        </li>
                        <li>
                            <Link className={clsx([defaultClasses, url.startsWith('/admin/settings') ? activeClasses : hoverClasses])} href="/admin/settings">Settings</Link>
                        </li>

                    </ul>
                    <ul className="flex space-x-9">
                        <li>
                            <a href="/" className={clsx([defaultClasses, hoverClasses])} >Website</a>
                        </li>
                        <li>
                            <a href="#" onClick={logout}>Logout ({appState.user?.email})</a>
                        </li>
                    </ul>
                </nav>
            </header>
            {children}
        </div>
    )
}
